export const STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

interface StatusBadgeProps {
  isActive: boolean;
  label?: string;
}

const StatusBadge = ({ isActive, label }: StatusBadgeProps) => (
  <span
    className={`px-2 py-1 text-xs rounded-full ${
      isActive ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
    }`}
  >
    {label || (isActive ? STATUS.ACTIVE : STATUS.INACTIVE)}
  </span>
);

export default StatusBadge;
